module.exports = __webpack_public_path__ + "media/images/category/feature/index/logo-index-poj-7cf0bf375e02663dbc417a1d3f151995.svg";